import { PromotionType, Currency, Status } from './types';

export const mapForDropdown = (items: string[]) => {
	return items.map((name) => ({ id: name, name: name.split('_').join(' ') }));
};

export const currencyValues: Currency[] = ['RSD', 'BAM', 'EUR', 'USD', 'GBP', 'RUB'];
export const promotionStatusValues: Status[] = ['ACTIVE', 'IN_CREATION', 'INACTIVE', 'DELETED'];
export const promotionTypeValues: PromotionType[] = ['TICKET_PROMOTION', 'DRINKS_PROMOTION', 'BONUS_VOUCHER_PROMOTION'];

export const cityTimeZoneArray = [
	'Asia/Dubai',
	'Asia/Kabul',
	'Asia/Yerevan',
	'Asia/Baku',
	'Asia/Dhaka',
	'Asia/Brunei',
	'Asia/Thimphu',
	'Asia/Shanghai',
	'Asia/Urumqi',
	'Asia/Nicosia',
	'Asia/Famagusta',
	'Asia/Tbilisi',
	'Asia/Hong_Kong',
	'Asia/Jakarta',
	'Asia/Pontianak',
	'Asia/Makassar',
	'Asia/Jayapura',
	'Asia/Jerusalem',
	'Asia/Kolkata',
	'Asia/Baghdad',
	'Asia/Tehran',
	'Asia/Amman',
	'Asia/Tokyo',
	'Asia/Bishkek',
	'Asia/Pyongyang',
	'Asia/Seoul',
	'Asia/Almaty',
	'Asia/Qyzylorda',
	'Asia/Qostanay',
	'Asia/Aqtobe',
	'Asia/Aqtau',
	'Asia/Atyrau',
	'Asia/Oral',
	'Asia/Beirut',
	'Asia/Colombo',
	'Asia/Yangon',
	'Asia/Ulaanbaatar',
	'Asia/Hovd',
	'Asia/Choibalsan',
	'Asia/Macau',
	'Asia/Kuala_Lumpur',
	'Asia/Kuching',
	'Asia/Karachi',
	'Asia/Gaza',
	'Asia/Hebron',
	'Asia/Kathmandu',
	'Asia/Yekaterinburg',
	'Asia/Qatar',
	'Asia/Omsk',
	'Asia/Novosibirsk',
	'Asia/Barnaul',
	'Asia/Tomsk',
	'Asia/Novokuznetsk',
	'Asia/Krasnoyarsk',
	'Asia/Irkutsk',
	'Asia/Chita',
	'Asia/Yakutsk',
	'Asia/Khandyga',
	'Asia/Vladivostok',
	'Asia/Ust-Nera',
	'Asia/Singapore',
	'Asia/Magadan',
	'Asia/Sakhalin',
	'Asia/Srednekolymsk',
	'Asia/Kamchatka',
	'Asia/Anadyr',
	'Asia/Bangkok',
	'Asia/Dushanbe',
	'Asia/Taipei',
	'Asia/Dili',
	'Asia/Ashgabat',
	'Asia/Damascus',
	'Asia/Riyadh',
	'Asia/Samarkand',
	'Asia/Tashkent',
	'Asia/Ho_Chi_Minh',
	'Europe/Andorra',
	'Europe/Tirane',
	'Europe/Vienna',
	'Europe/Brussels',
	'Europe/Sofia',
	'Europe/Minsk',
	'Europe/Zurich',
	'Europe/Prague',
	'Europe/Berlin',
	'Europe/Copenhagen',
	'Europe/Tallinn',
	'Europe/Madrid',
	'Europe/Helsinki',
	'Europe/Paris',
	'Europe/London',
	'Europe/Gibraltar',
	'Europe/Athens',
	'Europe/Budapest',
	'Europe/Dublin',
	'Europe/Rome',
	'Europe/Vilnius',
	'Europe/Luxembourg',
	'Europe/Riga',
	'Europe/Monaco',
	'Europe/Chisinau',
	'Europe/Malta',
	'Europe/Amsterdam',
	'Europe/Oslo',
	'Europe/Warsaw',
	'Europe/Lisbon',
	'Europe/Bucharest',
	'Europe/Belgrade',
	'Europe/Kaliningrad',
	'Europe/Moscow',
	'Europe/Simferopol',
	'Europe/Kirov',
	'Europe/Astrakhan',
	'Europe/Volgograd',
	'Europe/Saratov',
	'Europe/Ulyanovsk',
	'Europe/Samara',
	'Europe/Stockholm',
	'Europe/Istanbul',
	'Europe/Kiev',
	'Europe/Uzhgorod',
	'Europe/Zaporozhye',
	'Antarctica/Casey',
	'Antarctica/Davis',
	'Antarctica/DumontDUrville',
	'Antarctica/Mawson',
	'Antarctica/Palmer',
	'Antarctica/Rothera',
	'Antarctica/Syowa',
	'Antarctica/Troll',
	'Antarctica/Vostok',
	'Antarctica/Macquarie',
	'America/Argentina/Buenos_Aires',
	'America/Argentina/Cordoba',
	'America/Argentina/Salta',
	'America/Argentina/Jujuy',
	'America/Argentina/Tucuman',
	'America/Argentina/Catamarca',
	'America/Argentina/La_Rioja',
	'America/Argentina/San_Juan',
	'America/Argentina/Mendoza',
	'America/Argentina/San_Luis',
	'America/Argentina/Rio_Gallegos',
	'America/Argentina/Ushuaia',
	'America/Barbados',
	'America/La_Paz',
	'America/Belem',
	'America/Fortaleza',
	'America/Recife',
	'America/Araguaina',
	'America/Maceio',
	'America/Bahia',
	'America/Sao_Paulo',
	'America/Campo_Grande',
	'America/Cuiaba',
	'America/Porto_Velho',
	'America/Boa_Vista',
	'America/Manaus',
	'America/Eirunepe',
	'America/Rio_Branco',
	'America/Nassau',
	'America/Belize',
	'America/St_Johns',
	'America/Halifax',
	'America/Glace_Bay',
	'America/Moncton',
	'America/Goose_Bay',
	'America/Blanc-Sablon',
	'America/Toronto',
	'America/Nipigon',
	'America/Thunder_Bay',
	'America/Iqaluit',
	'America/Pangnirtung',
	'America/Atikokan',
	'America/Winnipeg',
	'America/Rainy_River',
	'America/Resolute',
	'America/Rankin_Inlet',
	'America/Regina',
	'America/Swift_Current',
	'America/Edmonton',
	'America/Cambridge_Bay',
	'America/Yellowknife',
	'America/Inuvik',
	'America/Creston',
	'America/Dawson_Creek',
	'America/Fort_Nelson',
	'America/Vancouver',
	'America/Whitehorse',
	'America/Dawson',
	'America/Santiago',
	'America/Punta_Arenas',
	'America/Bogota',
	'America/Costa_Rica',
	'America/Havana',
	'America/Curacao',
	'America/Santo_Domingo',
	'America/Guayaquil',
	'America/Cayenne',
	'America/Godthab',
	'America/Danmarkshavn',
	'America/Scoresbysund',
	'America/Thule',
	'America/Guatemala',
	'America/Guyana',
	'America/Tegucigalpa',
	'America/Port-au-Prince',
	'America/Jamaica',
	'America/Martinique',
	'America/Mexico_City',
	'America/Cancun',
	'America/Merida',
	'America/Monterrey',
	'America/Matamoros',
	'America/Caracas',
	'America/Mazatlan',
	'America/Chihuahua',
	'America/Ojinaga',
	'America/Hermosillo',
	'America/Tijuana',
	'America/Bahia_Banderas',
	'America/Managua',
	'America/Panama',
	'America/Lima',
	'America/Miquelon',
	'America/Puerto_Rico',
	'America/El_Salvador',
	'America/Grand_Turk',
	'America/Paramaribo',
	'America/Asuncion',
	'America/Port_of_Spain',
	'America/New_York',
	'America/Detroit',
	'America/Kentucky/Louisville',
	'America/Kentucky/Monticello',
	'America/Indiana/Indianapolis',
	'America/Indiana/Vincennes',
	'America/Indiana/Winamac',
	'America/Indiana/Marengo',
	'America/Indiana/Petersburg',
	'America/Indiana/Vevay',
	'America/Indiana/Tell_City',
	'America/Indiana/Knox',
	'America/Chicago',
	'America/Menominee',
	'America/Denver',
	'America/Boise',
	'America/Phoenix',
	'America/North_Dakota/Center',
	'America/North_Dakota/New_Salem',
	'America/North_Dakota/Beulah',
	'America/Los_Angeles',
	'America/Anchorage',
	'America/Juneau',
	'America/Sitka',
	'America/Metlakatla',
	'America/Yakutat',
	'America/Nome',
	'America/Adak',
	'America/Montevideo',
	'Pacific/Pago_Pago',
	'Pacific/Rarotonga',
	'Pacific/Easter',
	'Pacific/Galapagos',
	'Pacific/Fiji',
	'Pacific/Chuuk',
	'Pacific/Pohnpei',
	'Pacific/Kosrae',
	'Pacific/Guam',
	'Pacific/Majuro',
	'Pacific/Kwajalein',
	'Pacific/Tarawa',
	'Pacific/Enderbury',
	'Pacific/Kiritimati',
	'Pacific/Noumea',
	'Pacific/Norfolk',
	'Pacific/Nauru',
	'Pacific/Niue',
	'Pacific/Auckland',
	'Pacific/Chatham',
	'Pacific/Tahiti',
	'Pacific/Marquesas',
	'Pacific/Gambier',
	'Pacific/Port_Moresby',
	'Pacific/Bougainville',
	'Pacific/Pitcairn',
	'Pacific/Palau',
	'Pacific/Guadalcanal',
	'Pacific/Fakaofo',
	'Pacific/Tongatapu',
	'Pacific/Funafuti',
	'Pacific/Wake',
	'Pacific/Honolulu',
	'Pacific/Efate',
	'Pacific/Wallis',
	'Pacific/Apia',
	'Australia/Lord_Howe',
	'Australia/Hobart',
	'Australia/Currie',
	'Australia/Melbourne',
	'Australia/Sydney',
	'Australia/Broken_Hill',
	'Australia/Brisbane',
	'Australia/Lindeman',
	'Australia/Adelaide',
	'Australia/Darwin',
	'Australia/Perth',
	'Australia/Eucla',
	'Africa/Abidjan',
	'Africa/Algiers',
	'Africa/Cairo',
	'Africa/El_Aaiun',
	'Africa/Ceuta',
	'Africa/Accra',
	'Africa/Bissau',
	'Africa/Nairobi',
	'Africa/Monrovia',
	'Africa/Tripoli',
	'Africa/Casablanca',
	'Africa/Maputo',
	'Africa/Windhoek',
	'Africa/Lagos',
	'Africa/Khartoum',
	'Africa/Juba',
	'Africa/Sao_Tome',
	'Africa/Ndjamena',
	'Africa/Tunis',
	'Africa/Johannesburg',
	'Atlantic/Azores',
	'Atlantic/Bermuda',
	'Atlantic/Madeira',
	'Atlantic/Cape_Verde',
	'Atlantic/Canary',
	'Atlantic/Stanley',
	'Atlantic/Faroe',
	'Atlantic/South_Georgia',
	'Atlantic/Reykjavik',
	'Indian/Cocos',
	'Indian/Christmas',
	'Indian/Chagos',
	'Indian/Mauritius',
	'Indian/Maldives',
	'Indian/Mahe',
	'Indian/Reunion',
	'Indian/Kerguelen',
];

export const promotionTypes = mapForDropdown(promotionTypeValues);
export const currencies = mapForDropdown(currencyValues);
export const promotionStatuses = mapForDropdown(promotionStatusValues);
export const cityTimeZone = mapForDropdown(cityTimeZoneArray);
export const walletTypes = [
	{ id: 'INTERNET', name: 'INTERNET' },
	{ id: 'FB', name: 'FREE BET' },
	{ id: 'CASH', name: 'CASH' },
];
